import React from 'react';
import { Crown, Mail, MapPin, Phone } from 'lucide-react';
import { Page } from '../App';
interface FooterProps {
  onNavigate: (page: Page) => void;
}
function InstagramIcon() {
  return <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-48">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" data-id="element-49" />
    </svg>;
}
function TikTokIcon() {
  return <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-50">
      <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.75a4.85 4.85 0 01-1.01-.06z" data-id="element-51" />
    </svg>;
}
function FacebookIcon() {
  return <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-52">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-53" />
    </svg>;
}
function YouTubeIcon() {
  return <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" data-id="element-54">
      <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-55" />
    </svg>;
}
export function Footer({
  onNavigate
}: FooterProps) {
  return <footer className="bg-[#080808] border-t border-white/10 pt-16 pb-8" data-id="element-56">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12" data-id="element-58">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-59">
            <button onClick={() => onNavigate('home')} className="flex items-center gap-2 mb-4" data-id="element-60">
              <Crown className="w-5 h-5 text-[#D4AF37]" data-id="element-61" />
              <span className="text-xl font-bold font-serif text-white" data-id="element-62">
                LUXE <span className="text-[#D4AF37]" data-id="element-63">COLLECTIONS</span>
              </span>
            </button>
            <p className="text-gray-500 text-sm leading-relaxed mb-6" data-id="element-64">
              Living well — intentionally. Premium products delivered across
              Nigeria with transparent pricing and reliable service.
            </p>
            {/* Social Icons */}
            <div className="flex items-center gap-4" data-id="element-65">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 hover:text-[#E1306C] hover:border-[#E1306C]/40 hover:bg-[#E1306C]/10 transition-all" aria-label="Instagram" data-id="element-66">
                <InstagramIcon data-id="element-67" />
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 hover:text-white hover:border-white/40 hover:bg-white/10 transition-all" aria-label="TikTok" data-id="element-68">
                <TikTokIcon data-id="element-69" />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 hover:text-[#1877F2] hover:border-[#1877F2]/40 hover:bg-[#1877F2]/10 transition-all" aria-label="Facebook" data-id="element-70">
                <FacebookIcon data-id="element-71" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-gray-400 hover:text-[#FF0000] hover:border-[#FF0000]/40 hover:bg-[#FF0000]/10 transition-all" aria-label="YouTube" data-id="element-72">
                <YouTubeIcon data-id="element-73" />
              </a>
            </div>
          </div>

          {/* Shop */}
          <div data-id="element-74">
            <h4 className="text-white font-semibold mb-5 uppercase tracking-wider text-sm" data-id="element-75">
              Shop
            </h4>
            <ul className="space-y-3" data-id="element-76">
              {[{
              label: 'Fashion Accessories',
              page: 'fashion' as Page
            }, {
              label: 'Home Appliances',
              page: 'appliances' as Page
            }, {
              label: 'Electronics',
              page: 'electronics' as Page
            }].map(item => <li key={item.page} data-id="element-77">
                  <button onClick={() => onNavigate(item.page)} className="text-gray-500 hover:text-[#D4AF37] transition-colors text-sm" data-id="element-78">
                    {item.label}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-79">
            <h4 className="text-white font-semibold mb-5 uppercase tracking-wider text-sm" data-id="element-80">
              Company
            </h4>
            <ul className="space-y-3" data-id="element-81">
              {[{
              label: 'About Us',
              page: 'about' as Page
            }, {
              label: 'Track Order',
              page: 'track-order' as Page
            }, {
              label: 'Checkout',
              page: 'checkout' as Page
            }].map(item => <li key={item.page} data-id="element-82">
                  <button onClick={() => onNavigate(item.page)} className="text-gray-500 hover:text-[#D4AF37] transition-colors text-sm" data-id="element-83">
                    {item.label}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-84">
            <h4 className="text-white font-semibold mb-5 uppercase tracking-wider text-sm" data-id="element-85">
              Contact
            </h4>
            <ul className="space-y-3" data-id="element-86">
              <li className="flex items-start gap-3 text-gray-500 text-sm" data-id="element-87">
                <MapPin className="w-4 h-4 text-[#D4AF37] mt-0.5 flex-shrink-0" data-id="element-88" />
                Benin City, Edo State, Nigeria
              </li>
              <li className="flex items-center gap-3 text-gray-500 text-sm" data-id="element-89">
                <Mail className="w-4 h-4 text-[#D4AF37] flex-shrink-0" data-id="element-90" />
                support@luxecollections.ng
              </li>
              <li className="flex items-center gap-3 text-gray-500 text-sm" data-id="element-91">
                <Phone className="w-4 h-4 text-[#D4AF37] flex-shrink-0" data-id="element-92" />
                +234 800 000 0000
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-93">
          <p className="text-gray-600 text-xs" data-id="element-94">
            © {new Date().getFullYear()} Luxe Collections. All rights reserved.
            | NDPR Compliant | Nigeria-only delivery
          </p>
          <div className="flex items-center gap-4 text-gray-600 text-xs" data-id="element-95">
            <span data-id="element-96">Privacy Policy</span>
            <span data-id="element-97">·</span>
            <span data-id="element-98">Terms of Service</span>
            <span data-id="element-99">·</span>
            <span data-id="element-100">Refund Policy</span>
          </div>
        </div>
      </div>
    </footer>;
}